import React from 'react';

/**
 * Renders the header of a card component.
 *
 * @component
 * @param {Object} props - The props object.
 * @param {string} props.title - The title of the card.
 * @param {ReactNode} props.children - The content of the card header.
 * @returns {JSX.Element} The rendered card header.
 */
function CardHeader(props) {
	return (
		<h3 className="prc__card--title">
			<span className="prc__card--title-text">{props.title}</span>
			{props.children}
		</h3>
	);
}

export default CardHeader;
